// extracted by mini-css-extract-plugin
module.exports = {"editAndViewCapsuleModal":"EditAndViewCapsuleModal_editAndViewCapsuleModal__3Kpu6"};